import Input from './components/Input';
import ProgressBar from './components/ProgressBar';
import TagSelector from './components/TagSelector';
import Label from './components/Label';
import LabelGroup from './components/LabelGroup';

export const uikit = {
  Input,
  ProgressBar,
  TagSelector,
  Label,
  LabelGroup,
};
